import React, { useState } from "react";
import "./register.css";

const Register = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [message, setMessage] = useState(""); // State untuk menampilkan pesan

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validasi password cocok
    if (formData.password !== formData.confirmPassword) {
      setMessage("⚠ Password tidak cocok!");
      return;
    }

    try {
      const response = await fetch("https://database.kopicast.web.id/register.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: formData.username,
          email: formData.email,
          password: formData.password,
        }),
      });

      const result = await response.json(); // Ambil respon dari backend

      if (response.ok) {
        setMessage(`✅ ${result.message}`);
        setFormData({ username: "", email: "", password: "", confirmPassword: "" }); // Reset form
      } else {
        setMessage(`❌ ${result.message}`);
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("❌ Terjadi kesalahan, coba lagi nanti.");
    }
  };

  return (
    <div className="register-container">
      <form className="register-box" onSubmit={handleSubmit}>
        <h2>Register</h2>

        {message && <p className="message">{message}</p>}

        <input
          type="text"
          name="username"
          placeholder="Masukkan Username"
          value={formData.username}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Masukkan Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Masukkan Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="confirmPassword"
          placeholder="Konfirmasi Password"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
        />
        <button type="submit">Register</button>

        <p>
          Sudah punya akun? <a href="/">Login</a>
        </p>
      </form>
    </div>
  );
};

export default Register;
